export default "__VITE_ASSET__D0Pxz0uQ__"